import { render, staticRenderFns } from "./DraftsPanel.vue?vue&type=template&id=158b602e&scoped=true&"
import script from "./DraftsPanel.vue?vue&type=script&lang=js&"
export * from "./DraftsPanel.vue?vue&type=script&lang=js&"
import style0 from "./DraftsPanel.vue?vue&type=style&index=0&id=158b602e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158b602e",
  null
  
)

export default component.exports